import CrewneckProduct from '../../../features/productmen/components/CrewneckProduct';

export const CrewneckMen = () => {
  return (
    <div>
      <CrewneckProduct></CrewneckProduct>
    </div>
  )
};